import { apiClient } from "../lib/api-client";
import {
  ExportRequest,
  PaginatedResponse,
} from "../types/api.types";

export const exportService = {
  async exportVideo(projectId: string): Promise<ExportRequest> {
    const response = await apiClient.post<ExportRequest>(
      `/exports/${projectId}/export`
    );
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.message || "Export failed");
  },

  async getExportStatus(exportId: string): Promise<ExportRequest> {
    const response = await apiClient.get<ExportRequest>(
      `/exports/${exportId}/status`
    );
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.message || "Failed to fetch export status");
  },

  async getExportHistory(
    page = 1,
    limit = 10,
    search = ""
  ): Promise<PaginatedResponse<ExportRequest>> {
    const query = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (search) query.append("search", search);

    const response = await apiClient.get<{
      exports: ExportRequest[];
      pagination: any;
    }>(`/exports/history?${query.toString()}`);
    if (response.success && response.data) {
      return {
        items: response.data.exports,
        pagination: response.data.pagination,
      };
    }
    throw new Error(response.message || "Failed to fetch export history");
  },

  async deleteExport(exportId: string): Promise<void> {
    const response = await apiClient.delete(`/exports/${exportId}`);
    if (!response.success) {
      throw new Error(response.message || "Failed to delete export");
    }
  },
};
